import React from 'react';
// import theme from './ChangeRequestDetailsHistoryLog.module.scss';
import HistoryLogTable from '@/seller/components/HistoryLog/HistoryLogTable';
import { ChangeRequest } from '@/types';

interface ChangeRequestDetailsHistoryLogProps {
    changeRequest: ChangeRequest;
}

const ChangeRequestDetailsHistoryLog = ({ changeRequest }: ChangeRequestDetailsHistoryLogProps) => {
    return (
        <HistoryLogTable
            hiddenColumns={['objectName']}
            filter={{
                projectId: changeRequest.projectId,
                objectType: 'ChangeRequest',
                objectIds: [changeRequest.id],
            }}
        />
    );
};

export default ChangeRequestDetailsHistoryLog;
